import { ArchiAppsKeyType } from '../../keys/models/archiApps';

const archiApps: ArchiAppsKeyType = {
  aiStudio: 'AI Studio',
  create: 'Create archi app',
  createApp: 'Create App',
  delete: 'Delete archi app',
  deleteApp: 'Delete app',
  editApp: 'Edit app',
  editAiStudio: 'Edit Ai Studio',
  iframeUrl: 'iFrame App URL',
  missingIframeUrl: 'This app does not have a valid iFrame URL configured.',
  plural: 'Archi apps',
  singular: 'Archi app',
  update: 'Update archi app'
};

export default archiApps;
